import { OrganizationApp } from "@/features/organization-app";
import { createFileRoute } from "@tanstack/react-router";

type Path = {
  appPath?: string;
} & Partial<Record<string, unknown>>;

export const Route = createFileRoute(
  "/_auth/_organization-access/_overlay-sidebar/organization/$organizationSlug/private/$appSlug"
)({
  component: Private,
  validateSearch: (search: Record<string, unknown>): Path => search as Path
});

function Private() {
  const { appSlug, organizationSlug } = Route.useParams();
  const { appPath, ...appSearchParams } = Route.useSearch();

  return (
    <OrganizationApp
      appSlug={appSlug}
      organizationSlug={organizationSlug}
      appPath={appPath}
      appSearchParams={appSearchParams}
    />
  );
}
